module.exports = require("rxjs/operators/switchMap");


//////////////////
// WEBPACK FOOTER
// external "rxjs/operators/switchMap"
// module id = 852
// module chunks = 0